const optionCollator = new Intl.Collator('es', {
  numeric: true,
  sensitivity: 'base',
})

const normalizeLabel = (value) => String(value ?? '').trim()

export const sortByLabel = (items = [], getLabel = (item) => item?.label ?? item?.name ?? item) =>
  [...items].sort((a, b) =>
    optionCollator.compare(normalizeLabel(getLabel(a)), normalizeLabel(getLabel(b)))
  )

export const sortStrings = (items = []) => sortByLabel(items, (item) => item)
